import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentDocumentVaultService } from '../../../services/student-document-vault/student-document-vault.service';
import { OperationsService } from '../../../services/operations/operations.service';
import { DocumentCategoryEnum } from '../../../models/student-document-vault/student-document-vault';

@Component({
  selector: 'app-document-vault-sidebar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './document-vault-sidebar.component.html',
  styleUrl: './document-vault-sidebar.component.scss'
})
export class DocumentVaultSidebarComponent implements OnInit {
  @Input() isMobileView: boolean = false;
  @Output() closeSidebar = new EventEmitter<void>();
  @Output() onCategorySelect = new EventEmitter<DocumentCategoryEnum>();
  @Output() onStatusFilterSelect = new EventEmitter<number>();

  @Input() activeCategoryId: number | null = null;
  @Input() activeStatusFilter: number = 1;
  @Input() studentId: string | null = null;

  categoryCounts: { [key: number]: number } = {};
  get activeFilter(): string {
    if (this.activeStatusFilter === 2) return 'Uploaded';
    if (this.activeStatusFilter === 3) return 'Missing';
    return 'All Documents';
  }

  // All Documents section
  allDocuments = [
    { label: 'All Documents', count: 0 },
    { label: 'Uploaded', count: 0 },
    { label: 'Missing', count: 0 },
  ];

  byCategory = [
    { label: 'Identity', category: DocumentCategoryEnum.Identity },
    { label: 'Academics', category: DocumentCategoryEnum.Academics },
    { label: 'Essays', category: DocumentCategoryEnum.EssayPilot },
    { label: 'LORs', category: DocumentCategoryEnum.LOR },
    { label: 'Test Scores', category: DocumentCategoryEnum.TestScores },
    { label: 'Others', category: DocumentCategoryEnum.Other },
  ];

  byUniversity = [
    // { label: 'University Name', count: 1 },
    // { label: 'University Name', count: null },
  ];

  constructor(
    private docsService: StudentDocumentVaultService,
    private operationsService: OperationsService
  ) {}

  ngOnInit(): void {
    this.loadCategoryCounts();
  }

  loadCategoryCounts(): void {
    if (this.studentId) {
      // Operations Portal
      this.operationsService.getStudentCategoryCounts(this.studentId, this.activeStatusFilter).subscribe({
        next: (res: any) => {
          const counts = res.responseData || res.result || [];
          const map: { [key: number]: number } = {};
          let total = 0;
          counts.forEach((item: any) => {
            map[item.category] = item.count;
            total += item.count;
          });
          this.categoryCounts = map;
          this.allDocuments[0].count = total;
        }
      });
    } else {
      // Student Portal
      // First get status counts
      this.docsService.getStatusCounts().subscribe({
        next: (res: any) => {
          const status = res?.responseData ?? res?.result ?? { all: 0, uploaded: 0, missing: 0 };
          this.allDocuments[0].count = status.all;
          this.allDocuments[1].count = status.uploaded;
          this.allDocuments[2].count = status.missing;

          // Then get category counts with the same status filter
          this.docsService.getCategoryCounts(this.activeStatusFilter).subscribe({
            next: (res: any) => {
              const counts = res.responseData || res.result || [];
              const map: { [key: number]: number } = {};
              counts.forEach((item: any) => {
                map[item.category] = item.count;
              });
              this.categoryCounts = map;
            }
          });
        }
      });
    }
  }

  getCategoryCount(category: DocumentCategoryEnum): number {
    return this.categoryCounts[category] || 0;
  }

  selectCategory(category: DocumentCategoryEnum): void {
    this.activeCategoryId = category;
    this.onCategorySelect.emit(category);
    if (this.isMobileView) {
      this.closeSidebar.emit();
    }
  }

  selectFilter(label: string): void {
    this.activeCategoryId = null;
    
    let filter = 1;
    if (label === 'Uploaded') filter = 2;
    else if (label === 'Missing') filter = 3;
    
    this.onStatusFilterSelect.emit(filter);
    
    if (this.isMobileView) {
      this.closeSidebar.emit();
    }
  }

  onCloseClick() {
    this.closeSidebar.emit();
  }
}
